<template>
  <button type="button" title="Редактировать" class="edit-icon-btn">
    <SvgIcon icon="edit" />
  </button>
</template>

<script lang="ts" src="./EditIconBtn.ts"></script>

<style scoped lang="scss" src="./EditIconBtn.scss"></style>
